export default {
  title: "البلاد",
  subtitle: "إدارة البلاد والمناطق",
  
  // Actions
  addNew: "إضافة بلد جديد",
  createCountry: "إنشاء بلد",
  editCountry: "تعديل البلد",
  deleteCountry: "حذف البلد",

  actions: {
    back: "رجوع",
    update: "تحديث",
    updating: "جاري التحديث...",
    save: "حفظ",
    saving: "جاري الحفظ...",
    cancel: "إلغاء",
    edit: "تعديل",
    delete: "حذف"
  },
  
  // Fields
  fields: {
    name: "اسم البلد",
    code: "رمز البلد",
    iso2: "رمز ISO2",
    iso3: "رمز ISO3",
    phoneCode: "رمز الهاتف",
    phoneRegularExpression: "التعبير النمطي للهاتف",
    currency: "العملة",
    region: "المنطقة",
    subregion: "المنطقة الفرعية",
    capital: "العاصمة",
    flag: "العلم",
    status: "الحالة",
    type: "نوع البلد",
    symbol: "الرمز",
    warehouseAddress: "عنوان المستودع",
    warehouseAddressLine1: "عنوان المستودع - السطر الأول",
    warehouseAddressLine2: "عنوان المستودع - السطر الثاني",
    warehouseCity: "مدينة المستودع",
    warehousePostalCode: "الرمز البريدي للمستودع",
    warehousePhone: "هاتف المستودع",
    isActive: "حالة المستودع",
    isSuspended: "حالة التعليق",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث"
  },
  
  // Placeholders
  placeholders: {
    name: "أدخل اسم البلد",
    code: "أدخل رمز البلد",
    iso2: "أدخل رمز ISO2 (مثل: US)",
    iso3: "أدخل رمز ISO3 (مثل: USA)",
    phoneCode: "أدخل رمز الهاتف (مثل: +1)",
    phoneRegularExpression: "أدخل النمط (مثل: ^[0-9]{10}$)",
    currency: "أدخل رمز العملة (مثل: USD)",
    region: "أدخل المنطقة",
    subregion: "أدخل المنطقة الفرعية",
    capital: "أدخل العاصمة",
    flag: "أدخل رمز العلم أو الرابط",
    symbol: "أدخل رمز البلد",
    warehouseAddress: "أدخل عنوان المستودع",
    warehouseAddressLine1: "أدخل عنوان المستودع - السطر الأول (اختياري)",
    warehouseAddressLine2: "أدخل عنوان المستودع - السطر الثاني (اختياري)",
    warehouseCity: "أدخل اسم مدينة المستودع (اختياري)",
    warehousePostalCode: "أدخل الرمز البريدي للمستودع (اختياري)",
    warehousePhone: "أدخل رقم هاتف المستودع (اختياري)"
  },
  
  // Messages
  messages: {
    createSuccess: "تم إنشاء البلد بنجاح",
    createError: "فشل في إنشاء البلد",
    updateSuccess: "تم تحديث البلد بنجاح",
    updateError: "فشل في تحديث البلد",
    deleteSuccess: "تم حذف البلد بنجاح",
    deleteError: "فشل في حذف البلد",
    deleteConfirm: "هل أنت متأكد من حذف هذا البلد؟",
    noCountries: "لا توجد بلاد",
    loadingCountries: "جاري تحميل البلاد...",
    fetchError: "فشل في جلب البلاد"
  },
  
  // Validation
  validation: {
    nameRequired: "اسم البلد مطلوب",
    nameMinLength: "اسم البلد يجب أن يكون على الأقل حرفين",
    nameMaxLength: "اسم البلد يجب ألا يتجاوز 100 حرف",
    codeRequired: "رمز البلد مطلوب",
    codeFormat: "رمز البلد يجب أن يكون 2-3 أحرف",
    iso2Required: "رمز ISO2 مطلوب",
    iso2Format: "رمز ISO2 يجب أن يكون حرفين بالضبط",
    iso3Format: "رمز ISO3 يجب أن يكون 3 أحرف بالضبط",
    phoneCodeFormat: "رمز الهاتف يجب أن يبدأ بـ + ويحتوي على أرقام فقط",
    currencyFormat: "رمز العملة يجب أن يكون 3 أحرف (مثل: USD)",
    capitalMaxLength: "اسم العاصمة يجب ألا يتجاوز 100 حرف",
    symbolRequired: "الرمز مطلوب"
  },
  
  // Table headers
  table: {
    name: "الاسم",
    code: "الرمز",
    iso2: "ISO2",
    iso3: "ISO3",
    phoneCode: "رمز الهاتف",
    currency: "العملة",
    region: "المنطقة",
    capital: "العاصمة",
    flag: "العلم",
    status: "الحالة",
    suspended: "معلق",
    type: "النوع",
    symbol: "الرمز",
    actions: "خيارات الأوامر"
  },
  
  // Status options
  status: {
    active: "نشط",
    inactive: "غير نشط",
    suspended: "معلق",
    notSuspended: "غير معلق"
  },

  // Country types
  types: {
    both: "كلاهما",
    destination: "وجهة",
    source: "مصدر",
    notSet: "غير محدد"
  },
  
  // Regions
  regions: {
    africa: "أفريقيا",
    americas: "الأمريكتان",
    asia: "آسيا",
    europe: "أوروبا",
    oceania: "أوقيانوسيا",
    antarctica: "القارة القطبية الجنوبية"
  },
  
  // Breadcrumbs
  breadcrumbs: {
    countries: "البلاد",
    create: "إنشاء بلد",
    edit: "تعديل البلد",
    view: "عرض البلد"
  }
};
